import { render } from "./PortfolioFull.vue?vue&type=template&id=1d51bec4"
import script from "./PortfolioFull.vue?vue&type=script&lang=js"
export * from "./PortfolioFull.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__